import React from 'react';
import LookupManager from './LookupManager';

const CategoryComponent = () => {
    return (
        <LookupManager
            title="Category"
            endpoint="categories"
            placeholder="Category name"
            loadingLabel="Loading categories..."
            emptyLabel="No categories yet."
            includeHeader
        />
    );
};

export default CategoryComponent;
